var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02969 19.764H4.62968C3.41465 19.764 2.42968 18.779 2.42969 17.564L2.42977 4.36405C2.42978 3.14903 3.41475 2.16406 4.62977 2.16406H14.53C15.745 2.16406 16.73 3.14904 16.73 4.36406V8.76406M6.28003 6.56406H12.88M6.28003 9.86406H12.88M6.28003 13.1641H9.58003M12.3299 16.7308L16.9968 12.0639L20.108 15.1752L15.4411 19.8421H12.3299V16.7308Z",
    stroke: "#ffffff",
    strokeWidth: 1.8374,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageLogo);
export default __webpack_public_path__ + "static/media/PageLogo.c9e1823f40c236cade2bdfd967eedef9.svg";
export { ForwardRef as ReactComponent };